import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { FaInstagram, FaTwitter, FaFacebookF } from 'react-icons/fa';
// import Clefill from "../../../assets/svg/RO_footer.png";
import Logo from '../../../assets/svg/footer-logos';


const Footer = ({ setLocationModal }) => {

    const isValidLocation = useSelector(state => state.auth.isValidLocation)
    const history = useHistory()

    const handleRedirect = (path) => {
        if (!isValidLocation) {
            swal('Location unavailable !', 'Please select location !', 'error')
        } else {
            history.push(path)
        }
    }

    return (
        <>
        
            <div className='mob-footer'>
            <footer className="footer">
                <div className="footer-logo">
                    <h2>
                    <Logo  /> 
                        {/* <span className="footer-r">r</span>esponsible <span className="footer-ones">ones</span> */}
                        {/* <img src={Clefill} alt="responsible ones logo" className="footer-logo-img" /> */}
                    </h2>
                    <div className="social-icons">
                        <a
                            href="https://instagram.com/clefillproducts?igshid=YmMyMTA2M2Y="
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-icon"
                        >
                            <FaInstagram />
                        </a>
                        <a
                            href="https://twitter.com/clefillproducts?s=11&t=kZCCypuuVfaW2pIJHXkQYA"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-icon"
                        >
                            <FaTwitter />
                        </a>


                        <a
                            href="https://www.facebook.com/profile.php?id=100087878525201&mibextid=LQQJ4d"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-icon"
                        >
                            <FaFacebookF />
                        </a>
                        {/* <FaFacebookF /> */}
                    </div>
                </div>

                <div className="footer-links">
                    <div className="footer-column">
                        <a onClick={() => handleRedirect('/product_list/refill/all')}>Refills</a>
                        <a onClick={() => handleRedirect('/product_list/prefill/dish-wash-gel')}>Dishwash Gel</a>
                        <a onClick={() => handleRedirect('/product_list/prefill/laundry-care')}>Liquid Detergents</a>
                        <a onClick={() => handleRedirect('/product_list/prefill/floor-cleaner')}>Floor Cleaners</a>
                    </div>
                    <div className="footer-column">
                        <a onClick={() => handleRedirect('/product_list/prefill/glass-cleaner-')}>Glass Cleaner</a>
                        <a onClick={() => handleRedirect('/product_list/prefill/toilet-cleaner')}>Toilet Cleaner</a>
                        <a onClick={() => handleRedirect('/product_list/prefill/bathroom-cleaner')}>Bathroom Cleaner</a>
                        <a onClick={() => handleRedirect('/product_list/prefill/hand-wash')}>Hand Wash</a>
                    </div>
                    <div className="footer-column">
                        <a onClick={() => handleRedirect('/product_list/prefill/all')}>Shop All</a>
                        {/* <a href="#">Bestsellers</a> */}
                        <a onClick={() => handleRedirect('/subscribe_and_save')}>Subscribe & Save</a>
                    </div>
                    
                    <div className="footer-column">
                        <a onClick={() => handleRedirect('/about_clefill')}>Our Story</a>
                        <a onClick={() => handleRedirect('/contactus')}>Contact Us</a>
                        {/* <a href="#">FAQs</a> */}
                        <a onClick={() => handleRedirect('/cms/pp')}>Privacy Policy</a>
                        {/* <a href="#">Terms of Use</a> */}
                        <a onClick={() => handleRedirect('/cms/rrd')}>Return Policy</a>
                    </div>
                </div>
            </footer>
            
            <div className="copyright-footer">
                Copyright 2025, Clefill
            </div>
            </div>



        </>
    );
}

export default Footer;